import { noop } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function GenerateLazyComponent(): ClassDecorator {
  return noop;
}
